import Locale from '@models/Locale/model'
import Collection from '@models/Collection'

export default class LocaleCollection extends Collection {
  getModel () {
    return Locale
  }
}



// WEBPACK FOOTER //
// ./src/models/Locale/collection.js